import React from "react";
import { Alert } from "reactstrap";
import { statusFormatter } from "src/shared/utils/src";

type iProps = { 
    statusString: string 
}

const WarningStatusTag: React.FC<iProps> = ({ statusString }) => {

    return (
        <Alert color="warning" className="status-tag d-inline-flex align-items-center justify-content-center fs-12 fw-medium">
            { statusFormatter(statusString) }
        </Alert>
    )
}

export default WarningStatusTag;